import styled from "styled-components"

const Title = styled.h2`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const H1Title = styled.h1`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const Container = styled.div`
  color: black;
  & a {
    color: black;
    &::before {
      background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    }
  }
`
export { Title, H1Title, Container }
